//import images from 'assets/images/images'
import Product from 'components/home/Product'
import React from 'react'
import Slider from 'react-slick'

const GoWellTogether = ({getItem, isOpenDrawer, setIsOpenDrawer, setSingleDrawerProduct}) => {
 

  const settingsCampaigns = {
    //dots: true,
    infinite: true,
    speed: 2000,
    autoplay: true,
    autoplaySpeed: 3000,
    slidesToShow: getItem?.suggestedProducts.length < 3 ? getItem?.suggestedProducts.length : 3,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
    responsive: [
      {
        breakpoint: 1500,
        settings: {
          slidesToShow:  getItem?.suggestedProducts.length < 3 ? getItem?.suggestedProducts.length : 3,
          slidesToScroll: 1,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 1180,
        settings: {
          slidesToShow:  getItem?.suggestedProducts.length < 2 ? getItem?.suggestedProducts.length : 2,
          slidesToScroll: 1,
          infinite: true,
          //dots: true
        }
      },
      {
        breakpoint: 700,
        settings: {
          slidesToShow: 1.5,
          slidesToScroll: 1,
          initialSlide: 1,
          navigator: false
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll:1,
          initialSlide: 1
        }
      }
    ]
  };
  return (
    <div className='goWellTogether'>
      {
        getItem?.suggestedProducts.length > 0 && (
          <Slider {...settingsCampaigns}>
            {
              getItem?.suggestedProducts.map((product, i) => (
                <Product componentName="product detail - slider" isOpenDrawer={isOpenDrawer} setIsOpenDrawer={setIsOpenDrawer} setSingleDrawerProduct={setSingleDrawerProduct} key={i} product={product} />
              ))
            }
          </Slider>
        )
      }
       
    </div>
  )
}

export default GoWellTogether